module.exports = __webpack_public_path__ + "assets/no-notifications.3a26af5a.svg";